import { cloneDeep } from 'lodash'
import { TEntityMaskItem } from '~/types/models'

interface IGetEntityInputFields {
  callingMn: string
  entityName: string
}

// Per-entity input-field modules, resolved via Vite's `import.meta.glob` instead of a
// runtime `import(`~/…/${entityName}`)`. Vite cannot analyze a bare aliased template
// specifier and throws "Failed to resolve module specifier" at runtime (webpack built a
// dynamic-import context for it; Vite does not). Each module exports `inputFields`; the
// loaders stay lazy so per-entity chunks still code-split. The `!./modules/*.test.ts`
// negative replaces the old `webpackExclude` — co-located specs are never bundled.
const inputFieldsLoaderByEntity: Record<
  string,
  () => Promise<TEntityMaskItem[]>
> = Object.fromEntries(
  Object.entries(
    import.meta.glob(['./modules/*.ts', '!./modules/*.test.ts'], {
      import: 'inputFields',
    }) as Record<string, () => Promise<TEntityMaskItem[]>>
  ).map(([path, loader]) => [
    // './modules/user.ts' -> 'user'
    path.slice(path.lastIndexOf('/') + 1).replace(/\.ts$/, ''),
    loader,
  ])
)

export async function getEntityInputFields(obj: IGetEntityInputFields) {
  const { callingMn, entityName } = obj
  const fn = `${callingMn} ---> [services/.../getEntityInputFields.ts] getEntityInputFields |`
  console.debug(`${fn} Getting input fields for entity: ${entityName}`)

  const loadInputFields = inputFieldsLoaderByEntity[entityName]
  if (!loadInputFields) {
    console.warn(
      `${fn} no input-fields module for '${entityName}' — returning []`
    )
    return { inputFields: [] as TEntityMaskItem[] }
  }

  const inputFieldsToExport = await loadInputFields()
  const inputFields = cloneDeep(inputFieldsToExport)
  console.debug(`${fn} returning inputFields: `, inputFields)
  return { inputFields }
}

export function filterEntityMaskItems({
  entityMaskItems,
  route,
}: {
  entityMaskItems: TEntityMaskItem[]
  route: string | undefined
}) {
  // Currently not supporting different
  // EntityMaskItems for 'Locations'.JR.
  const routeToUse = route === 'Locations' ? 'Companies' : route
  //
  const filtered = []
  for (const item of entityMaskItems) {
    if (
      !item.showForRoutes ||
      item.showForRoutes.length < 1 ||
      !routeToUse ||
      item.showForRoutes.includes(routeToUse)
    ) {
      filtered.push(item)
    }
  }
  return filtered
}
